const state = {
    isMapView: false,
    defaultZoomLevel: [],
};


export { state };